import OnspacePlayerDebug from '@onpace/onspace-media/elements/player/debug'

/// The Onspace Player Debug element displays debugging information and controls for an audio player.
export default class OnspaceAudioPlayerDebug extends OnspacePlayerDebug {
}

window.customElements.define('onspace-audio-debug', OnspaceAudioPlayerDebug)
